import { useTranslation } from "@/i18n/LanguageContext";

export default function TermsAndConditions() {
  const t = useTranslation();
  const sections = t("terms.sections");

  return (
    <div className="min-h-screen bg-background px-6 py-10">
      <div className="mx-auto max-w-4xl space-y-6 rounded-lg border border-border bg-card p-6 shadow-sm">
        <div className="space-y-2">
          <div className="mono-eyebrow">{t("terms.eyebrow")}</div>
          <h1 className="font-display text-3xl tracking-tight" data-testid="terms-page-title">
            {t("terms.title")}
          </h1>
          <p className="text-sm text-muted-foreground">
            {t("terms.intro")}
          </p>
        </div>

        {sections.map((section) => (
          <section key={section.title} className="space-y-3 text-sm leading-6">
            <h2 className="font-display text-xl tracking-tight">{section.title}</h2>
            {section.paragraphs?.slice(0, section.list ? 1 : undefined).map((paragraph, index) => (
              <p key={`${section.title}-${index}`}>{paragraph}</p>
            ))}
            {section.list && (
              <ul className="list-disc space-y-2 pl-5 text-sm text-muted-foreground">
                {section.list.map((item) => (
                  <li key={item}>{item}</li>
                ))}
              </ul>
            )}
            {section.list && section.paragraphs?.slice(1).map((paragraph, index) => (
              <p key={`${section.title}-after-list-${index}`}>{paragraph}</p>
            ))}
          </section>
        ))}
      </div>
    </div>
  );
}
